// non-accented characters are also included in this string so that corresponding accented characters can be matched
const accents = 'AÀÁÂÃÄÅaàáâãäåOÒÓÔÕÖØoòóôõöøEÈÉÊËeèéêëðCÇcçDÐIÌÍÎÏiìíîïUÙÚÛÜuùúûüNÑnñSŠsšYŸyÿýZŽzž- ';

// this assumes the regex is case-insensitive as only lowercases are returned in the character groups
const accentsInsensitive = [
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[aàáâãäå]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[oòóôõöø]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[eèéêëð]',
  '[cç]',
  '[cç]',
  '[cç]',
  '[cç]',
  '[DÐ]',
  '[DÐ]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[iìíîï]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[uùúûü]',
  '[nñ]',
  '[nñ]',
  '[nñ]',
  '[nñ]',
  '[sš]',
  '[sš]',
  '[sš]',
  '[sš]',
  '[yÿý]',
  '[yÿý]',
  '[yÿý]',
  '[yÿý]',
  '[yÿý]',
  '[zž]',
  '[zž]',
  '[zž]',
  '[zž]',
  '[ -]',
  '[ -]',
];

// from unity3
function generateAccentsRegex(query) {
  if (!query) return '';

  return query
    .replace(/[\\/<>="*~^%|#()+`@;.]/gi, '')
    .split('')
    .reduce((prev, current) => {
      if (accents.indexOf(current) === -1) {
        return [...prev, current];
      } else {
        return [...prev, accentsInsensitive[accents.indexOf(current)]];
      }
    }, [])
    .join('');
}

export const accentInsensitiveRegex = (query, prefix = false) => new RegExp(`${prefix ? '^' : ''}(${generateAccentsRegex(query)})`, 'gi');

const highlightResult = (text, highlighted = false) => ({ text, highlighted });

export const highlightMatches = (text, searchText) => {
  if (!text) return [];
  if (!searchText) return [highlightResult(text)];

  const accentsRegex = accentInsensitiveRegex(searchText);

  const highlights = [];
  let matchIndex = 0;
  let match = accentsRegex.exec(text);

  while (match) {
    if (match.index > matchIndex) {
      highlights.push(highlightResult(text.substring(matchIndex, match.index)));
    }
    highlights.push(highlightResult(match[0], true));

    if (accentsRegex.lastIndex === matchIndex) break;
    matchIndex = accentsRegex.lastIndex;

    match = accentsRegex.exec(text);
  }

  if (matchIndex < text.length) {
    highlights.push(highlightResult(text.substring(matchIndex)));
  }

  return highlights;
};
